import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { PlayCount } from '../../models'
import { PlayCountApi } from '../../apis'

export abstract class PlayCountService {
  constructor(
    protected api: PlayCountApi
  ) { }

  index(videoId: number, groupIds?: number[]) {
    return this.api.index(videoId, groupIds)
  }

  show(videoId: number, userId: number): Observable<PlayCount> {
    return this.api.show(videoId, userId)
  }

  heatmap(videoId: number, groupIds?: number[]) {
    return this.api.heatmap(videoId, groupIds)
  }
}



// WEBPACK FOOTER //
// ./src/services/play-count/base.ts